import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import "./Register.css";
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";
import login_image from "../../assets/images/login/login-image.png";
import google from "../../assets/images/login/google.svg";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { useTranslation } from "../../contexts/TranslationContext";
import debounce from "lodash.debounce";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { axiosGet } from "../../utils/apis/api";

const Register = ({ url, data, translations, language }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    nationality: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();

  const [firstnameError, setFirstnameError] = useState("");
  const [lastnameError, setLastnameError] = useState("");
  const [nationalityError, setNationalityError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [loginError, setLoginError] = useState("");

  const [registrationMessage, setRegistrationMessage] = useState("");
  const [registrationType, setRegistrationType] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const [natQuery, setNatQuery] = useState("");
  const [natOptions, setNatOptions] = useState([]);
  const [natLoading, setNatLoading] = useState(false);

  // const fetchNationalities = useMemo(
  //   () =>
  //     debounce(async (q = "") => {
  //       try {
  //         setNatLoading(true);
  //         const params = q ? { search: q, limit: 20 } : { limit: 20 };
  //         const { data } = await axios.get(
  //           "https://crm.alltimestravels.com/api/method/alltimes.www.api.countries",
  //           { params }
  //         );
  //         setNatOptions(data.result.countries || []);
  //       } catch (e) {
  //         console.error(e);
  //       } finally {
  //         setNatLoading(false);
  //       }
  //     }, 300),
  //   []
  // );

  const fetchNationalities = useMemo(
    () =>
      debounce(async (q = "") => {
        try {
          setNatLoading(true);
          const params = q ? { search: q, limit: 20 } : { limit: 20 };
          const data = await axiosGet(
            "https://crm.alltimestravels.com/api/method/alltimes.www.api.countries",
            params
          );
          setNatOptions(data?.result?.countries || []);
        } catch (e) {
          console.error(e);
        } finally {
          setNatLoading(false);
        }
      }, 300),
    []
  );

  useEffect(() => {
    fetchNationalities(natQuery);
  }, [natQuery, fetchNationalities]);

  useEffect(() => () => fetchNationalities.cancel(), [fetchNationalities]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handlePhoneChange = (value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      phoneNumber: value,
    }));
  };

  const validateForm = () => {
    let isValid = true;
    setFirstnameError("");
    setLastnameError("");
    setEmailError("");
    setNationalityError("");

    if (!formData.firstName.trim()) {
      setFirstnameError(t("FirstNameIsRequired"));
      isValid = false;
    }

    if (!formData.lastName.trim()) {
      setLastnameError(t("LastNameIsRequired"));
      isValid = false;
    }

    if (!formData.nationality.trim()) {
      setNationalityError(t("NationalityIsRequired"));
      isValid = false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (formData.email.trim() && !emailRegex.test(formData.email)) {
      setEmailError(t("EmailValidation"));
      isValid = false;
    } else {
      setEmailError("");
    }


    if (!formData.phoneNumber) {
      setLoginError(t("PhoneNumberIsRequired"));
      isValid = false;
    } else {
      setLoginError(""); 
    }

    return isValid;
  };


  useEffect(() => {
    const fetchRegistrationType = async () => {
      try {
        const response = await axiosGet(
          "https://crm.alltimestravels.com/api/method/alltimes.www.auth.registration_type"
        );
        const byPhone = response?.result?.by_phone;
        setRegistrationType(byPhone);
      } catch (error) {
        console.error("Failed to fetch registration type:", error);
      }
    };

    fetchRegistrationType();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      setIsSubmitting(false);
      return;
    }

    setIsSubmitting(true);

    // const apiUrl = `https://crm.alltimestravels.com/`;
    const apiUrl = `https://crm.alltimestravels.com/api/method/alltimes.www.auth.register`;

    const requestBody = {
      // cmd: "frappe.core.doctype.user.user.sign_up",
      full_name: `${formData.firstName} ${formData.lastName}`,
      nationality: formData.nationality,
      email: formData.email,
      phone: formData.phoneNumber,
      // website_user: "1",
      // redirect_to: `/app/user/${formData.email}`,
    };

    try {
      const response = await axios.post(apiUrl, requestBody, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      // if (response.status === 200) {
      //   navigate("/checkemail", { state: { email: formData.email } });
      // }
      if (response.status === 200) {       
        if (registrationType === 1) {
          navigate("/checkemail", { state: { phone: formData.phoneNumber } });
        } else if (registrationType === 0) {
          navigate("/checkemail", { state: { email: formData.email } });
        }
      }

    } catch (error) {
      console.error(error);
      setRegistrationMessage(t("RegistrationFailed"));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="auth register">
      <Container>
        <div className="row" style={{ alignItems: "center" }}>
          <Col lg={4} md={5} sm={12}>
            <h1 className="login-title"> {t("Register")}</h1>
            <p className="login-para">
              {t("RegisterText")}
            </p>
            <form className="login-fields" onSubmit={handleSubmit}>
              <div className="input-wrapper">
                <label className="register-label">{t("FirstName")}</label>
                <input
                  className={`login-field user-field ${
                    firstnameError ? "error" : ""
                  }`}
                  placeholder={t("FirstName")}
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                />
              </div>
              {firstnameError && (
                <p className="error-message">{firstnameError}</p>
              )}

              <div className="input-wrapper">
                <label className="register-label">{t("LastName")}</label>
                <input
                  className={`login-field user-field ${
                    lastnameError ? "error" : ""
                  }`}
                  placeholder={t("LastName")}
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                />
              </div>
              {lastnameError && (
                <p className="error-message">{lastnameError}</p>
              )}

              <div className="input-wrapper">
                <label className="register-label"> {t("Nationality")}</label>
                <Autocomplete
                  options={natOptions}
                  style={{ width: "100%" }}
                  className="nationality-text"
                  loading={natLoading}
                  getOptionLabel={(o) => o.name || ""}
                  value={
                    natOptions.find((o) => o.name === formData.nationality) ||
                    null
                  }
                  onInputChange={(_, v) => setNatQuery(v)}
                  onChange={(_, v) =>
                    setFormData((p) => ({
                      ...p,
                      nationality: v?.name || "",
                    }))
                  }
                  renderInput={(p) => (
                    <TextField
                      {...p}
                      size="small"
                      placeholder={t("SelectNationality")}
                    />
                  )}
                />
                {nationalityError && (
                  <p className="error-message">{nationalityError}</p>
                )}
              </div>

              <div className="input-wrapper">
                <label className="register-label">{t("Email")}</label>
                <input
                  type="email"
                  className={`login-field user-field ${
                    emailError ? "error" : ""
                  }`}
                  placeholder={t("Email")}
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>
              {emailError && <p className="error-message">{emailError}</p>}

              <div className="contact-input">
                <p className="contact-input-title">{t("PhoneNumber")}</p>
                <PhoneInput
                  placeholder="Enter phone number"
                  value={formData.phoneNumber}
                  onChange={handlePhoneChange}
                  country="US"
                  defaultCountry={"US"}
                  international
                  className="contact-input-text"
                  disabled={isLoading}
                  required
                />
              </div>

              <div className="login-btn">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={`login-submit ${isLoading ? "disabled" : ""}`}
                >
                  {isSubmitting ? "Submitting..." : t("SignUp")}
                </button>
                {/* <a href="#" className="sign-google">
                        <img src={google} alt="Google" />
                            {t("SignUpWithGoogle")}
                        </a> */}
              </div>
              {loginError && <p className="error-message">{loginError}</p>}
            </form>
            <div className="no-account">
              <p>{t("DoHaveAccount")}</p>
              <Link to="/login">{t("SignInNow")}</Link>
            </div>
          </Col>
          <Col lg={8} md={7} sm={6} className="display-image-col">
            <img
              src={login_image}
              alt="Login"
              className="login-img register-img"
            />
          </Col>
        </div>
      </Container>
    </div>
  );
};

export default Register;


